<div class="spinner-container flex-layout center-content">
  <div class="flex-layout center-content">
    <span class="loading-message">{{loadingMessage}}</span>
    <mat-spinner [diameter]="25" [strokeWidth]="4"></mat-spinner>
  </div>
</div>